// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

label {
  margin-bottom: 8px;
}

.select__control {
  height: 56px !important;
  margin-bottom: 24px !important;
}
.select__placeholder.css-14el2xx-placeholder {
  width: fit-content;
  position: relative;
  left: 13px;
  color: #aaaaaa;
}
.select__indicator-separator {
  margin: 0 !important;
}
.select__indicators {
  width: 52px;
  cursor: pointer;
}
.select__indicator.select__dropdown-indicator {
  padding-left: 15px;
}
.select__control.select__control--is-focused.css-1pahdxg-control:hover {
  border-color: NONE;
  box-shadow: none;
}
.select__control.select__control--is-focused.css-1pahdxg-control {
  box-shadow: none;
  border: 2px solid #0abf53;
}
.select__control.css-1s2u09g-control:hover {
  border-color: none;
}
.select__single-value {
  line-height: 24px;
}
.select__value-container--is-multi {
  max-height: 54px;
  overflow-y: auto !important;
  overflow-x: hidden;
}

.info-icon {
  border: none;
  background-color: transparent;
  margin-left: 5px;
}

.tooltip {
  visibility: hidden;
  width: auto;
  background-color: #ccc;
  color: black;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 2;
  margin-top: -5px;
  margin-left: 5px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.info-icon:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.label-info {
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAGE;EACE,uBAAA;EACA,8BAAA;AAAJ;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AAEE;EACE,WAAA;EACA,eAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,yBAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,2BAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AADF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,UAAA;AAAF;;AAGA;EACE,YAAA;AAAF","sourcesContent":[".dropdown-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\nlabel {\n  margin-bottom: 8px;\n}\n\n.select {\n  &__control {\n    height: 56px !important;\n    margin-bottom: 24px !important;\n  }\n  &__placeholder.css-14el2xx-placeholder {\n    width: fit-content;\n    position: relative;\n    left: 13px;\n    color: #aaaaaa;\n  }\n  &__indicator-separator {\n    margin: 0 !important;\n  }\n  &__indicators {\n    width: 52px;\n    cursor: pointer;\n  }\n  &__indicator.select__dropdown-indicator {\n    padding-left: 15px;\n  }\n  &__control.select__control--is-focused.css-1pahdxg-control:hover {\n    border-color: NONE;\n    box-shadow: none;\n  }\n  &__control.select__control--is-focused.css-1pahdxg-control {\n    box-shadow: none;\n    border: 2px solid #0abf53;\n  }\n  &__control.css-1s2u09g-control:hover {\n    border-color: none;\n  }\n  &__single-value {\n    line-height: 24px;\n  }\n  &__value-container--is-multi {\n    max-height: 54px;\n    overflow-y: auto !important;\n    overflow-x: hidden;\n  }\n}\n\n.info-icon {\n  border: none;\n  background-color: transparent;\n  margin-left: 5px;\n}\n.tooltip {\n  visibility: hidden;\n  width: auto;\n  background-color: #ccc;\n  color: black;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 2;\n  margin-top: -5px;\n  margin-left: 5px;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: 12px;\n}\n\n.info-icon:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.label-info {\n  padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
